import { EventType } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { loginRequest, msalInstance } from "./msal";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Render loading screen immediately — prevents white screen while MSAL initialises
root.render(
	<div
		style={{
			minHeight: "100vh",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			background: "#0f172a",
		}}
	>
		<p style={{ color: "#94a3b8", fontFamily: "sans-serif" }}>Loading…</p>
	</div>,
);

msalInstance.initialize().then(async () => {
	// Handle redirect from Microsoft login FIRST
	try {
		const tokenResponse = await msalInstance.handleRedirectPromise();
		if (tokenResponse) {
			msalInstance.setActiveAccount(tokenResponse.account);
			// Always land on /portal after a successful Microsoft login redirect
			if (window.location.pathname !== "/portal") {
				window.location.replace("/portal");
				return;
			}
		} else {
			const accounts = msalInstance.getAllAccounts();
			if (accounts.length > 0) {
				msalInstance.setActiveAccount(accounts[0]);
			}
		}
	} catch (error) {
		console.error("MSAL redirect error:", error);
	}

	// Check auth BEFORE rendering App — avoids false-negative on first render
	const accounts = msalInstance.getAllAccounts();
	if (accounts.length === 0) {
		await msalInstance.loginRedirect(loginRequest);
		return;
	}

	msalInstance.addEventCallback((event) => {
		if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
			msalInstance.setActiveAccount(event.payload.account);
		}
	});

	root.render(
		<React.StrictMode>
			<MsalProvider instance={msalInstance}>
				<App />
			</MsalProvider>
		</React.StrictMode>,
	);
});
